import { useMemo } from 'react';

import { useFeatureFlag } from '@spotify/confidence-core-react';

import type { IdentityKind } from '../../utils';
import {
  IdentityAutocompleteMui,
  IdentityAutocompleteMuiProps,
} from '../IdentityAutocomplete';

const GROUP_ONLY_KINDS: IdentityKind[] = ['group'];

/** @deprecated Legacy MUI copy - migrate consumers to the Encore OwnerAutocomplete and delete. */
export function OwnerAutocompleteMui<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
>(props: IdentityAutocompleteMuiProps<Multiple, DisableClearable>) {
  const { enabled: groupsOnly } = useFeatureFlag('owner-groups-only', {
    enabled: false,
  });

  const allowedKinds = useMemo(
    () => (groupsOnly ? GROUP_ONLY_KINDS : undefined),
    [groupsOnly],
  );

  return <IdentityAutocompleteMui allowedKinds={allowedKinds} {...props} />;
}
